import { Note, NoteSet } from '../types/note';


export const isBlackKey = (note: Note): boolean => {
  return [1, 3, 6, 8, 10].includes(note.value % 12);
};

export function isWhiteKey(note: Note) {
    return !isBlackKey(note);
}

export function hashNotes(notes: NoteSet): number {
  let key = 0;
  for (const note of notes) {
    key |= (1 << (note.value % 12));
  }
  return key;
}
